<template>
  <div class="head">
    <a
      href="https://forbes.hu"
      target="_blank"
    ><img
        class="forbeslogo"
        src="../assets/img/forbes-white.svg"
        alt="Forbes"
      ></a>
  </div>
</template>

<script>
export default {
  name: 'HeadComponent',
  props: {

  },
};
</script>

<style scoped lang="css">
.head {
  grid-template-rows: 100px;
  grid-template-columns: 55px 1fr;
}
a {
  grid-column: 2/3;
  grid-row: 1/2;
  align-self: center;
}
.forbeslogo {
  height: 34px;
  width: 108px;
}
@media screen and (max-width: 767px) {
  .head {
    grid-template-rows: 70px;
    grid-template-columns: 20px 1fr;
  }
}
</style>
